export default {
  SCHEDULED: 'scheduled',
  ACTIVE: 'active',
  COMPLETED: 'completed',
  LEADERBOARD: 'leaderboard',
  DELETED: 'deleted',
};
